// extracted by mini-css-extract-plugin
export default {"globalNav":"globalNav___rVvlM","globalNavOpen":"globalNavOpen___FlZMO","globalNavFixed":"globalNavFixed___CjqVw"};